// src/components/LandingPage.jsx
import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./LandingPage.module.css";
import HeroComponent from "../NewLandingComponents/HeroComponent/HeroComponent";
import LandingPageSection2 from "../NewLandingComponents/LandingPageSection2/LandingPageSection2";
import LandingPageSection3 from "../NewLandingComponents/LandingPageSection3/LandingPageSection3";
import LandingPageSection4 from "../NewLandingComponents/LandingPageSection4/LandingPageSection4";
import LandingPage5 from "../NewLandingComponents/LandingPage5/LandingPage5";
import Testimonials from "../NewLandingComponents/Testimonials/Testimonials";
import LandingPageSection6 from "../NewLandingComponents/LandingPageSection6/LandingPageSection6";
import FAQComponent from "../NewLandingComponents/FAQComponent/FAQComponent";
import VoicePopup from "../../VoicePopup/VoicePopup";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const LandingPage = () => {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Select all sections within the landing page container
    const sections = containerRef.current.children;

    // Apply animation to each section as it scrolls into view
    Array.from(sections).forEach((section) => {
      // Skip the VoicePopup element or excluded sections
      if (
        section.classList.contains("voice-popup-class") || 
        section.classList.contains("no-scroll-animation")
      ) return;

      gsap.fromTo(
        section,
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%", // Animates when top of section is 80% down the viewport
            toggleActions: "play none none none",
            once: true, // Only animate once
          },
        }
      );
    });

    return () => {
      // Clean up triggers on unmount
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.container}>
      {/* Hero Section */}
      <HeroComponent />

      {/* Growth/Analytics Section */}
      <LandingPageSection4 />

      {/* Features Section */}
      <LandingPageSection2 />

      {/* AI Team Section */}
      <LandingPageSection3 selectedAgent={selectedAgent} setSelectedAgent={setSelectedAgent} />

      {/* Workflow & Use Cases Section (No general scroll up) */}
      <div className="no-scroll-animation">
        <LandingPage5 />
      </div>

      {/* Integrations, Setup & Scale Section (No general scroll up) */}
      <div className="no-scroll-animation">
        <LandingPageSection6 />
      </div>

      {/* Testimonials Section */}
      <Testimonials />

      {/* FAQ Section */}
      <FAQComponent />
    </div>
  );
};

export default LandingPage;